import { render, staticRenderFns } from "./NewProjectPreview.vue?vue&type=template&id=2a3c0205&"
import script from "./NewProjectPreview.vue?vue&type=script&lang=js&"
export * from "./NewProjectPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports